export enum PublisherEvent {
    ANTD_ERROR_MESSAGE = 'antdErrorMessage',
    NAVIGATE = 'navigate',
}
